// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--kuC39","header":"_1410bfd27b--header--eurNp","slide":"_1410bfd27b--slide--tDW_B"};